/**
 * Created by fers on 26.09.15.
 */

import { declareEntity } from '../fw/MetaDataHelper.ts';
import { v4 as uuidv4 } from 'uuid';

export default declareEntity({
    entity: "dataStats",
    graphQL: "DataStat",
    name: "Data Statistics",
    dynamoPrefix: 'sys',
    storageType: 'central',
    fields: (types) => { return {
        id: {
            name: "ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
        },
        dataType: {
            name: "Data Type",
            type: "string",
        },
        dataValue: {
            name: "Data Length",
            type: "int",
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            filterable: true,
            userEditable: false,
        },

    }; },
    relations: (types) => { return {
    }; }
});
